import React from 'react';

import RichtextParser from '../../../utils/richtext-parser';
import Intro4 from '../../intro4';
import parseStoryblokLink from '../../../utils/parse-storyblok-link';
import { getFluidGatsbyImage } from '../../../utils/gatsby-storyblok-image-fixed';

function StoryblokIntroIconicLinksAdapter({
  links,
  bottomText,
  backgroundImage,
  ...rest
}) {
  return (
    <Intro4
      {...rest}
      links={links.map((v) => ({
        ...v,
        id: v._uid,
        text: v.description,
        icon: getLinkImageProps(v.icon),
        link: parseStoryblokLink(v.link),
      }))}
      bottomText={RichtextParser(bottomText)}
      backgroundImage={getFluidGatsbyImage(backgroundImage, {
        maxWidth: 2560,
      })}
      centerItems={rest.centerLinks}
    />
  );
}

const getLinkImageProps = (image) => {
  if (!image) return;

  if (image.filename.endsWith('.svg')) {
    return {
      aspectRatio: 1,
      width: 88,
      height: 88,
      src: image.filename,
    };
  }

  return getFluidGatsbyImage(image);
};

export default StoryblokIntroIconicLinksAdapter;
